module.exports = __webpack_public_path__ + "2c06408885da63a17cc06d618219eee2.pdf";